<template>
  <div class="dialog-img" v-if="imgUrl && visible" @click="handleShadow">
    <div class="dialog-img__close" @click="handleClose">
      <i class="el-icon-close"></i>
    </div>

    <img
      class="dialog-img__image"
      :src="imgUrl"
      style="transform: translate(-50%, -50%) scale(1)"
      alt=""
      ref="img"
    />
  </div>
</template>

<script>
export default {
  name: "dialog-img",
  props: {
    imgUrl: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scale: 1,
    };
  },
  mounted() {
    document.addEventListener("mousewheel", this.wheelScroll);
  },
  methods: {
    wheelScroll(e) {
      if (this.$props.imgUrl && this.$props.visible) {
        if (!this.$refs.img) return;
        let delta = e.wheelDelta;
        if (delta > 0) {
          if (this.scale + 0.03 < 1.5) {
            this.scale = this.scale + 0.03;
          } else {
            this.scale = 1.5;
          }
        } else {
          if (this.scale - 0.03 > 0.2) {
            this.scale = this.scale - 0.03;
          } else {
            this.scale = 0.2;
          }
        }
        this.$refs.img.style.transform = `translate(-50%, -50%) scale(${this.scale})`;
      }
    },
    handleClose() {
      this.$emit("close");
      this.scale = 1;
    },
    handleShadow(e) {
      const el = e.target;
      if (el !== this.$refs.img) this.handleClose();
    }
  },
  beforeDestroy() {
    document.removeEventListener("mousewheel", this.wheelScroll);
  }
};
</script>

<style lang="scss" scoped>
.dialog-img {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5000;
  background: rgba(0, 0, 0, 0.5);

  &__close {
    cursor: pointer;
    position: absolute;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    opacity: 0.8;
    cursor: pointer;
    box-sizing: border-box;
    user-select: none;
    top: 40px;
    right: 40px;
    width: 40px;
    height: 40px;
    font-size: 24px;
    color: #fff;
    background-color: #606266;
  }

  &__image {
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
